import { Link } from 'react-router-dom';
import Logo from '@/components/base/Logo';
import Icon from '@/components/base/Icon';


const footerLinks = [
  {
    slug: 'cerca-eletrica',
    name: 'Cerca Elétrica',
    url: 'https://www.eletronica2000.com.br/cerca-eletrica-campo-mourao',
  },
  {
    slug: 'cameras',
    name: 'Câmeras de Segurança',
    url: 'https://www.eletronica2000.com.br/cameras-seguranca-campo-mourao',
  },
  {
    slug: 'portao',
    name: 'Portão Eletrônico',
    url: 'https://www.eletronica2000.com.br/portao-eletronico-campo-mourao',
  },
  {
    slug: 'alarme',
    name: 'Alarme Residencial',
    url: 'https://www.eletronica2000.com.br/alarme-residencial-campo-mourao',
  },
  {
    slug: 'seguranca-rural',
    name: 'Segurança Rural',
    url: 'https://www.eletronica2000.com.br/seguranca-rural',
  },
  {
    slug: 'assistencia',
    name: 'Assistência Técnica',
    url: 'https://www.eletronica2000.com.br/assistencia-tecnica',
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#1a1a2e] text-white">
      <div className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1 flex flex-col gap-4">
            <Logo className="h-10 w-auto object-contain brightness-0 invert" />
            <p className="text-white/80 text-sm leading-relaxed">
              Especialistas em segurança eletrônica em Campo Mourão – PR desde
              1993. CFTV, alarmes, cercas elétricas, automatização de portões e
              segurança rural para chácaras e fazendas.
            </p>
            <div className="flex items-center gap-3 mt-1">
              <a
                href="https://wa.me/5544997181872?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento."
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-emerald-700 flex items-center justify-center hover:bg-emerald-800 transition-colors"
                aria-label="WhatsApp Orçamento"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <Icon name="whatsapp" className="text-white" size={16} />
                </div>
              </a>
              <a
                href="mailto:contato@eletronica2000.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center hover:bg-emerald-700 transition-colors"
                aria-label="E-mail"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <Icon name="mail" className="text-white" size={16} />
                </div>
              </a>
            </div>
          </div>

          {/* Site Oficial */}
          <div className="flex flex-col gap-3">
            <span className="text-xs font-bold tracking-widest text-emerald-400 uppercase">
              Site Oficial
            </span>
            <div className="flex flex-col gap-2">
              {footerLinks.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 text-sm hover:text-white hover:pl-1 transition-all"
                >
                  {cat.name}
                </a>
              ))}
              <a
                href="https://www.eletronica2000.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 text-sm hover:text-white hover:pl-1 transition-all"
              >
                Página Principal
              </a>
              <Link
                to="/"
                className="text-white/80 text-sm hover:text-white hover:pl-1 transition-all"
              >
                Blog
              </Link>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-col gap-3">
            <span className="text-xs font-bold tracking-widest text-emerald-400 uppercase">
              Navegação
            </span>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-white/80 text-sm hover:text-white hover:pl-1 transition-all"
              >
                Blog
              </Link>
              <a
                href="https://www.eletronica2000.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 text-sm hover:text-white hover:pl-1 transition-all"
              >
                Site Oficial
              </a>
              <a
                href="https://wa.me/5544997181872?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento."
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 text-sm hover:text-emerald-400 hover:pl-1 transition-all"
              >
                Orçamento
              </a>
            </div>
          </div>

          {/* Contato */}
          <div className="flex flex-col gap-3">
            <span className="text-xs font-bold tracking-widest text-emerald-400 uppercase">
              Contato
            </span>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <Icon name="map-pin" className="text-emerald-400" size={16} />
                </div>
                <p className="text-white/80 text-sm">
                  Campo Mourão – Paraná
                  <br />
                  Brasil
                </p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <Icon name="whatsapp" className="text-emerald-400" size={16} />
                </div>
                <a
                  href="https://wa.me/5544997181872?text=Olá!%20Gostaria%20de%20falar%20com%20um%20especialista."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80 text-sm hover:text-emerald-400 transition-colors"
                >
                  (44) 99718-1872
                </a>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <Icon name="mail" className="text-emerald-400" size={16} />
                </div>
                <a
                  href="mailto:contato@eletronica2000.com.br"
                  className="text-white/80 text-sm hover:text-emerald-400 transition-colors"
                >
                  contato@eletronica2000.com.br
                </a>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <Icon name="time" className="text-emerald-400" size={16} />
                </div>
                <p className="text-white/80 text-sm">
                  Seg-Sex: 8h às 18h
                  <br />
                  Sábado: 8h às 12h
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-white/70 text-xs text-center sm:text-left">
            <p>
              © {new Date().getFullYear()} Eletrônica 2000. Todos os direitos
              reservados.
            </p>
            <p className="mt-1">
              Segurança Eletrônica · CNPJ: 13.590.059/0001-29 · Claudia Regina
              da Silva
            </p>
          </div>
          <div className="flex items-center gap-5">
            <Link
              to="/"
              className="text-white/70 text-xs hover:text-white transition-colors"
            >
              Blog
            </Link>
            <Link
              to="/admin"
              className="text-white/70 text-xs hover:text-white transition-colors"
            >
              Área Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}